import React, { useState } from "react";
import "./home.scss";
import Modal from "../Widgets/Modal";
import PriceSlider from "../Widgets/priceSlider";
import MapComponent from "../Widgets/MapComponent";
import video from "../../Assets/video-home.mp4";
import { GrLocation } from "react-icons/gr";
import { BsSend  } from "react-icons/bs";
import { FiFacebook, FiInstagram } from "react-icons/fi";
import { BsListTask } from "react-icons/bs";
import { TbApps } from "react-icons/tb";
import { FaRegLightbulb, FaRegUser } from "react-icons/fa";
import { MdOutlineMailOutline } from "react-icons/md";

const Home = () => {
 //States for toggleButtons
  const [selectedOption, setSelectedOption] = useState(1);
  const handleButtonClick = (option) => {
    setSelectedOption(option);
    setAddress("");
    const tipos = [
      "Inversión a corto plazo",
      "Inversión a mediano plazo",
      "Inversión a largo plazo",
      "Construcción de vivienda",
      "Ejidal",
    ];
    setFormData({
      ...formData,
      tipoInversion: tipos[option - 1],
      precio: infoPorOpcion[option].value
    });
  };

  //States for dropdown
  const [usoSuelo, setUsoSuelo] = useState('');

  const [isOpen, setIsOpen] = useState(false);

  const [frente, setFrente] = useState("");
  const [fondo, setFondo] = useState("");
  const [superficie, setSuperficie] = useState("");
  const [isSuperficieManual, setIsSuperficieManual] = useState(false);

  const handleFrenteChange = (event) => {
    const value = event.target.value;
    if(value >= 0){
      setFrente(value);
      if(!isSuperficieManual && value && fondo){
        setSuperficie(value * fondo);
      }
    }
    setFormData({
      ...formData,
      frente: value,
      superficie: formData.isSuperficieManual ? formData.superficie : value * formData.fondo
    });
  }

  const handleFondoChange = (event) => {
    const value = event.target.value;
    if(value >= 0){
      setFondo(value);
      if(!isSuperficieManual && value && frente){
        setSuperficie(value * frente);
      }
    }
    setFormData({
      ...formData,
      fondo: value,
      superficie: formData.isSuperficieManual ? formData.superficie : value * formData.frente
    });
  }

  const handleSuperficieChange = (event) => {
    const value = event.target.value;
    if(value >= 0){
      setSuperficie(value);
      setIsSuperficieManual(!!value);
      if(value) {
        setFrente("");
        setFondo("");
      }
    }
    setFormData({
      ...formData,
      superficie: value,
      isSuperficieManual: !!value
    });
  }

  // Información específica para cada opción
  const infoPorOpcion = {
    1: {
      zonaPlaceholder: "Zona para inversión a corto plazo...",
      precioMin: 500,
      precioMax: 1000000,
      value: 1000,
      caracteristicasPlaceholder: "Amenidades para corto plazo...",
    },
    2: {
      zonaPlaceholder: "Zona para inversión a mediano plazo...",
      precioMin: 100,
      precioMax: 1500000,
      value: 10000,
      caracteristicasPlaceholder: "Amenidades para mediano plazo...",
    },
    3: {
      zonaPlaceholder: "Zona para inversión a largo plazo...",
      precioMin: 15000,
      precioMax: 2000000,
      value: 90000,
      caracteristicasPlaceholder: "Amenidades para largo plazo...",
    },
    4: {
      zonaPlaceholder: "Zona para construcción de vivienda...",
      precioMax: 2500000,
      precioMin: 2000,
      value: 10000,
      caracteristicasPlaceholder: "Amenidades para vivienda...",
    },
    5: {
      zonaPlaceholder: "Zona ejidal...",
      precioMin: 5000,
      value: 100000,
      precioMax: 500000,
      caracteristicasPlaceholder: "Amenidades para terrenos ejidales...",
    },
  };

  const [formData, setFormData] = useState({
    tipoInversion: 'Inversión a corto plazo',
    zona: '',
    usoSuelo: '',
    precio: infoPorOpcion[1].value,
    caracteristicas: '',
    nombre: '',
    email: '',
    cita: '',
    frente: '',
    fondo: '',
    superficie: '',
    isSuperficieManual: false
  });

  const infoActual = infoPorOpcion[selectedOption];

  const [address, setAddress] = useState("");

  const handleAddressChange = (e) => {
    setFormData({...formData, zona: e.target.value});
  };

  const handleUsoSueloChange = (e) => {
    setFormData({...formData, usoSuelo: e.target.value});
    setFormData({...formData, usoSuelo: e.target.value});
  };

  const handlePrecioChange = (value) => {
    setFormData({...formData, precio: value});
  };

  const handleCaracteristicasChange = (e) => {
    setFormData({...formData, caracteristicas: e.target.value});
  };

  const handleNombreChange = (e) => {
    setFormData({...formData, nombre: e.target.value});
  };

  const handleEmailChange = (e) => {
    setFormData({...formData, email: e.target.value});
  };

  const handleCitaChange = (e) => {
    setFormData({...formData, cita: e.target.value});
  };

  const handleMapClick = (coords) => {
    console.log("Coordenadas:", coords);
  };

  const sendToWhatsApp = () => { 
    // Validación básica
    if (!formData.nombre || !formData.email) {
      alert('Por favor complete los datos de contacto');
      return;
    }

    // Formatear fecha si existe
    const fechaCita = formData.cita ? new Date(formData.cita).toLocaleString('es-MX') : 'No solicitada';

    // Crear mensaje estructurado
    const message = `*Nueva solicitud de ${formData.tipoInversion}*\n\n` +
      `*Zona:* ${formData.zona || 'No especificada'}\n` +
      `*Uso de suelo:* ${formData.usoSuelo || 'No especificado'}\n` +
      `*Precio máximo:* $${formData.precio.toLocaleString('es-MX')}\n` +
      `*Características deseadas:* ${formData.caracteristicas || 'No especificadas'}\n` +
      `*Medidas:* Frente ${formData.frente || '0'}m, Fondo ${formData.fondo || '0'}m, Superficie ${formData.superficie || '0'}m²\n\n` +
      `*Datos de contacto*\n` +
      `Nombre: ${formData.nombre}\n` +
      `Email: ${formData.email}\n` +
      `Cita agendada: ${fechaCita}`;

    const encodedMessage = encodeURIComponent(message);
     
    const phoneNumber = '529992359443'; 
    
    // Crear enlace de WhatsApp
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    // Abrir en nueva pestaña
    window.open(whatsappUrl, '_blank');
  }


  return (
    <section className="home">
      <div className="overlay"></div>
      <video src={video} muted autoPlay loop type="video/mp4"></video>

      <div className="homeContent container">
        <div className="textDiv">
          <span className="smallText">Somos tu mejor opción</span>
          <h1 className="homeTitle">¿Buscas terrenos en yucatán?</h1>
        </div>

        <div className="cardDiv">
          <div className="toggleButtonGroup">
            <button
              className={`toggle-button ${
                selectedOption === 1 ? "active" : ""
              }`}
              onClick={() => handleButtonClick(1)}
            >
              Inversión a corto plazo
            </button>
            <button
              className={`toggle-button ${
                selectedOption === 2 ? "active" : ""
              }`}
              onClick={() => handleButtonClick(2)}
            >
              Inversión a mediano plazo
            </button>
            <button
              className={`toggle-button ${
                selectedOption === 3 ? "active" : ""
              }`}
              onClick={() => handleButtonClick(3)}
            >
              Inversión a largo plazo
            </button>
            <button
              className={`toggle-button ${
                selectedOption === 4 ? "active" : ""
              }`}
              onClick={() => handleButtonClick(4)}
            >
              Construcción de vivienda 
            </button>
            <button
              className={`toggle-button ${
                selectedOption === 5 ? "active" : ""
              }`}
              onClick={() => handleButtonClick(5)}
            >
              Ejidal
            </button>
          </div>

          {/* Sección de mapa y dirección */}
          <div className="destinationInput">
            <label htmlFor="city">Indique una zona:</label>
            <div className="input flex">
              <input
                type="text"
                placeholder={infoPorOpcion[selectedOption].zonaPlaceholder}
                value={formData.zona}
                onChange={handleAddressChange}
              />
              <GrLocation className="icon" />
            </div>

            {/* Componente del mapa */}
            <MapComponent 
              address={formData.zona}
              onAddressChange={(addr) => setFormData({...formData, zona: addr})}
              onMapClick={handleMapClick}
              apiKey=""
            />
          </div>

          <div className="usoSueloInput">
            <label htmlFor="suelo">Uso de suelo</label>
            <div className="input flex">
              <select
                id="suelo"
                value={formData.usoSuelo}
                onChange={handleUsoSueloChange}
                >
                <option value="">Selecciona el uso de suelo</option>
                <option value="Residencial">Residencial</option>
                <option value="Comercial">Comercial</option>
                <option value="Industrial">Industrial</option>
                <option value="Recreativo">Recreativo</option>
                <option value="Mixto">Mixto</option>
                <option value="Agropecuario">Agropecuario</option>
                <option value="Turistico">Turístico</option>
              </select>
              <FaRegLightbulb className="icon" />
            </div>
          </div>

          <PriceSlider
            min={infoPorOpcion[selectedOption].precioMin}
            max={infoPorOpcion[selectedOption].precioMax}
            value={formData.precio}
            onChange={handlePrecioChange} 
          />

          <div className="textInput">
            <label htmlFor="caract">Características ideales</label>
            <div className="input flex">
              <input
                type="text"
                placeholder="Describe las amenidades que deseas"
                value={formData.caracteristicas}
                onChange={handleCaracteristicasChange}
              />
              <FaRegLightbulb className="icon" />
            </div>
          </div>
          
          <div className="nameInput">
            <label htmlFor="name">Nombre</label>
            <div className="input flex">
              <input 
                type="text" 
                placeholder="Datos de contacto"
                value={formData.nombre}
                onChange={handleNombreChange}
                required 
              />
              <FaRegUser className="icon" />
            </div>
          </div>

          <div className="emailInput">
            <label htmlFor="email">Email</label>
            <div className="input flex">
              <input 
                type="text" 
                placeholder="Datos de contacto" 
                value={formData.email}
                onChange={handleEmailChange}
                required
              />
              <MdOutlineMailOutline className="icon" />
            </div>
          </div>

          <div className="dateInput">
              <label htmlFor="date">¿Desea agendar una cita?</label>
              <div className="input flex">
                  <input 
                    type="datetime-local"
                    value={formData.cita}
                    onChange={handleCitaChange}  
                />
              </div>
          </div>

          <div className="frente">
              <label htmlFor="frente">Frente:</label>
              <div className="input flex">
                  <input 
                    type="number" 
                    placeholder="Metros"
                    value={frente}
                    onChange={handleFrenteChange}
                    disabled={isSuperficieManual}
                    />
              </div>
          </div>

          <div className="fondo">
              <label htmlFor="fondo">Fondo:</label>
              <div className="input flex">
                  <input 
                    type="number" 
                    placeholder="Metros"
                    value={formData.fondo}
                    onChange={handleFondoChange}
                    disabled={formData.isSuperficieManual}
                    />
              </div>
          </div>

          <div className="superficie">
              <label htmlFor="superficie">Superficie:</label>
              <div className="input flex">
                  <input 
                    type="number" 
                    placeholder="Metros cuadrados"
                    value={formData.superficie}
                    onChange={handleSuperficieChange}
                  />
              </div>
              {formData.isSuperficieManual && (
              <p className="hint">Este campo se calcula automáticamente al ingresar frente y fondo. Borre y agregue frente y fondo si lo requiere</p>
          )}
          </div>
          {/* Fin */}
          

          <div className="searchOptions flex" onClick={sendToWhatsApp}>
            <BsSend className="icon"></BsSend>
            <span>Enviar</span>
          </div>
          {isOpen && <Modal setIsOpen={setIsOpen} />}
        </div>

        <div className="homeFooterIcons flex">
          <div className="rightIcons">
            <FiFacebook className="icon"></FiFacebook>
            <FiInstagram className="icon"></FiInstagram>
          </div>
          <div className="leftIcons">
            <BsListTask className="icon" />
            <TbApps className="icon" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
